import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const token = localStorage.getItem('admin_token');
      const stored = localStorage.getItem('admin_user');
      if (token && stored) {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.role === 'admin') {
          setUser(parsed);
        } else {
          // Invalid or non-admin user data — clear it
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
        }
      }
    } catch {
      // Corrupted localStorage data — clear it
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data.success && data.data) {
      if (data.data.user.role !== 'admin') {
        throw new Error('Access denied. Admin privileges required.');
      }
      localStorage.setItem('admin_token', data.data.token);
      localStorage.setItem('admin_user', JSON.stringify(data.data.user));
      setUser(data.data.user);
      return data.data;
    }
    throw new Error(data.message || 'Login failed');
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}
